<template>
  <v-row style="border: 0px solid blue;">
    <div>
      <span :class="[{'purple--text': isEqual}, {'red--text': !isEqual}]">
        {{ k }}
      </span>
      :
      &nbsp;
    </div>
    <template>
      <row :item1="item1" :item2="item2" :settings="settings"></row>
    </template>

  </v-row>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['k', 'item1', 'item2', 'settings'],
  name: 'kv-row',
  components: {
    'row': () => import('./row')
  },
  computed: {
    isEqual () {
      return _.isEqual(this.item1, this.item2)
    }
  }
}
</script>
